<div class="contact">
    <table class="contact-table">
        <tr>
            <th>Name:</th>
            <td>{{ contactItem.name }}</td>
        </tr>    
        <tr>
            <th>Email:</th>
            <td>{{ contactItem.email }}</td>
        </tr>
        <tr>
            <th>Subject:</th>
            <td>{{ contactItem.subject }}</td>
        </tr>
        <tr class="message">
            <th>Message:</th>
            <td>{{ contactItem.message }}</td>
        </tr>
    </table>
</div>

